<template>
  <a-row class="map_container">
      <div id="map"></div>
      <ul>
        <li>
          <div class="map_info_icon">
            <img src="../../assets/icons/map_car_icon.svg" alt="">
          </div>
          <span>{{carStatusText}}</span>{{ carSpeed }} km/h
        </li>
        <li>
          <div class="map_info_icon">
            <img src="../../assets/icons/map_clock_icon.svg" alt="">
          </div>
          {{this.currentCarInfo.time ? $moment(this.currentCarInfo.time).format('YYYY-MM-DD HH:mm') : '--'}}
        </li>
        <li>
          <div class="map_info_icon">
            <img src="../../assets/icons/map_location_icon.svg" alt="">
          </div>
          {{locationText}}
          <a-button type="text" class="exchange-icon" :class="(isExpired || !hasUpdatedRecord)? 'disabled':'disabled'" ghost size="small" @click="toggleAddressLocation">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none">
              <path d="M5.17496 8.17516L3.99996 7.00016L0.666626 10.3335L3.99996 13.6668L5.17496 12.4918L3.85829 11.1668H16.5V9.50016H3.85829L5.17496 8.17516Z" fill="#638D0A"/>
              <path d="M12.825 5.82516L14 7.00016L17.3333 3.66683L14 0.333496L12.825 1.5085L14.1416 2.8335H1.49996V4.50016H14.1416L12.825 5.82516Z" fill="#638D0A"/>
            </svg>
          </a-button>

        </li>
      </ul>
      <button v-show="!hasUpdatedRecord" class="no_record_btn">該車尚無上傳紀錄<br>請將車輛啟動後，再次嘗試</button>
      <button v-show="webSocketConnectFail" class="no_record_btn">連線錯誤</button>
      <button v-show="isExpired" class="expired_btn">服務已到期 (點選此按鈕前往續約)</button>
  </a-row>
</template>

<script>
  import Map from "ol/Map";
  import View from "ol/View";
  import { Tile as TileLayer } from 'ol/layer';
  import { XYZ, Vector } from 'ol/source';
  import { fromLonLat } from 'ol/proj';
  import { GeoJSON } from 'ol/format';
  import Feature from 'ol/Feature';
  import { Point } from 'ol/geom';
  import drivingIcon from "../../assets/icons/car_status_driving.svg";
  import flameoutIcon from "../../assets/icons/car_status_flameout.svg";
  import lostIcon from "../../assets/icons/car_status_lost.svg";
  import idleIcon from "../../assets/icons/car_status_Idle.svg";
  import VectorLayer from 'ol/layer/VectorImage';
  import { Style, Icon } from 'ol/style';
  import { defaults } from "ol/control";
  import {defaults as defaultInteractions} from 'ol/interaction'
  import { io } from "socket.io-client";
  import '../../../node_modules/ol/ol.css';
  import { mapState } from 'vuex';

  // 圖磚URL
  const url = 'https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}';
  // 興聯科技經緯度座標
  // const dafaultPosition = [121.4591572, 25.0601437];
  // 台灣地理中心碑經緯度座標
  const dafaultPosition = [120.947204, 23.9518411];
  // 限制地圖可拖拉的範圍界限(因為地圖縮到很小時，超出圖磚範圍的地方會有空白，故限制可拖拉的大概範圍為整個台灣本島)
  // const extentBound = boundingExtent([[118.230796, 19.807473], [123.229752, 26.60011]]);
  // 設定圖磚的圖層
  const tileLayer = new TileLayer({
    source: new XYZ({
      url,
    }),
  });
  // 行駛中marker樣式
  const drivingMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: drivingIcon,
    }),
  });
  // 熄火marker樣式
  const flameoutMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: flameoutIcon,
    }),
  });
  // 失聯marker樣式
  const lostMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: lostIcon,
    }),
  });
  // 怠速中marker樣式
  const idleMarkerStyle = new Style({
    image: new Icon({
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: idleIcon,
    }),
  });

// const MAX_CLIENTS = 300;

  export default {
    name: 'IndividualInfoMonitorMap',
    data() {
      return {
        mapCenter: fromLonLat(this.adjustCenterCoordinate(dafaultPosition)),
        zoom: 7,
        featureCoordinate: [],
        map: null,
        currentCarInfo: {
          carStatus: 0,
          speed: '--',
          time: '',
          longitude: '--',
          latitude: '--',
          azimuth: null,
          gpsSpeed:0
        },
        deviceStatus: 0,
        hasUpdatedRecord: true,
        isExpired: false,
        webSocketConnectFail: false,
        ws: null,
        clientCount: 0,
        tenＭinutes: 1000*60*10,
        productName:'',
        isAddress: false
      }
    },
    mounted() {
      this.initiateMap();
      this.establishSocketIo();
    },
    methods: {
      initiateMap() {
        this.map = new Map({
          target: "map",
          layers: [tileLayer],
          view: this.view,
          controls: defaults({
            zoom: false, // 關閉左上角的縮放按鈕控件
          }),
          interactions: defaultInteractions({
            pinchRotate: false // 移動端禁止地圖旋轉
          }),
        });

        // 監聽地圖縮放事件，進行縮放時將目前的zoom存到sessionStorage
        this.map.getView().on('change:resolution', () => {
            sessionStorage.setItem('currentMonitorMapZoom', this.map.getView().getZoom());
        })
      },
      establishSocketIo () {
        if(this.ws) {
          console.log("disconnect socket")
          this.ws.disconnect();
        }


        let ioUrl = '';
        const envFile = process.env.ENV_FILE;
        if(envFile === undefined || Object.is(envFile,'local')){
          // ioUrl = 'https://open.hino-itraq.com.tw'
          ioUrl = process.env.VUE_APP_SOCKET_URL;
        }else {
          ioUrl = process.env.VUE_APP_SOCKET_URL;
        }

        const fullUrl = `${ioUrl}/activate`;
        this.ws = io(fullUrl, {
          path: "/socket",
          transports: [ "websocket" ],
        });

        console.log('fullUrl',fullUrl);


        // 限制重連線retry次數，若重試達到設定的次數，斷開連接，不再重試
        this.ws.io.reconnectionAttempts([12]);

        this.ws.on("connect", () => {
          console.log('socket connected');
        });

        this.ws.on("disconnect", (reason) => {
          console.log('socket disconnected');
          console.log('reason', reason);
        });

        this.ws.io.on('reconnect_attempt', attempt => {
            console.log( '目前重連次數：' + attempt );
        });

        this.ws.io.on('reconnect', attempt => {
            console.log('成功重新連接');
            console.log( '總共重連次數：' + attempt );
            this.establishSocketIo();
        });

        this.ws.io.on('reconnect_failed', () => {
            console.log( "重連失敗" );
            this.webSocketConnectFail = true;
        });

        //emit自定義事件，後面字串是自定義的，前端主動發送deviceuid(QRCode)給後端的資料，後端也要寫相對應的去接收。
        this.ws.emit('subscribe', { encodedImei: this.deviceUid }, res => {
          console.log("response from emit", res);

          // 根據回傳資料是否為空，來顯示無上傳資料提示
          this.hasUpdatedRecord = Object.keys(res.data).length ? true : false;
          // 若回傳的狀態是已到期，顯示服務已到期提示
          this.isExpired = res.status === 6 ? true : false;
          // this.initiateMap();
          // 考慮車輛acc還沒on起來時，emit回傳的資料為空，故只有在回傳有資料時再添加點位圖層
          if (Object.keys(res.data).length) {
            let { data: { carStatus, speed, time, longitude, latitude, azimuth , gpsSpeed, productName}, status } = res;
            this.currentCarInfo = { //取得新的車輛資料
              carStatus,
              speed,
              time,
              longitude,
              latitude,
              azimuth,
              gpsSpeed
            };
            this.deviceStatus = status;
            this.productName = productName;
            console.log('productName====',productName,gpsSpeed)
            this.updatePointLayerInfo(); //由這裡更新車輛的資料
          }
        });
        // on:後端更新前端資料，前端被動的接收資料
        this.ws.on('monitor', (res) => {
          console.log("response from listen", res);
          // 根據回傳資料是否為空，來顯示無上傳資料提示
          this.hasUpdatedRecord = Object.keys(res.data).length ? true : false;
          // 若回傳的狀態是已到期，顯示服務已到期提示
          this.isExpired = res.status === 6 ? true : false;

          let { data: { drivingStatus, canSpeed, time, lon, lat, azimuth, gpsSpeed }} = res;

          this.currentCarInfo = {
            carStatus: drivingStatus,
            speed: canSpeed,
            time,
            longitude:lon,
            latitude: lat,
            azimuth,
            gpsSpeed
          };
          this.deviceStatus = drivingStatus;
          this.updatePointLayerInfo();
        });

        // if (++this.clientCount < MAX_CLIENTS) {
        //   // console.log(this.clientCount);
        //   setTimeout(this.establishSocketIo, 10);
        // }
      },
      updatePointLayerInfo() {
        const { longitude, latitude } = this.currentCarInfo;
        // 1.先移除原先的車機layer
        this.map.removeLayer(this.pointsLayer);
        //2.再重畫
        this.map.getView().setCenter(fromLonLat(this.adjustCenterCoordinate([longitude, latitude])));
        this.featureCoordinate = [this.currentCarInfo.longitude || '--', this.currentCarInfo.latitude || '--'];
        // 3.最後再將新的資訊塞進去
        this.map.addLayer(this.pointsLayer);
      },
      adjustCenterCoordinate(coordinate) {
        // 若目前zoom是預設的7，則讓緯度往上移0.8，讓點位在整個螢幕中間位置
        let [longitude, latitude] = coordinate;
        let offsetNum = 0;

        if (this.map) {
          offsetNum = this.map.getView().getZoom() === 7 ? 0.8 : 0;
        }else offsetNum = 0.8;

        return [longitude, latitude - offsetNum];
      },
      toggleAddressLocation(){
        console.log(this.isAddress);
        return this.isAddress = !this.isAddress;
      }
    },
    computed: {
      ...mapState('identidyOpenStatus', ['deviceUid']),
      // 設定地圖的視圖
      view() {
        return new View({
          center: this.mapCenter,
          zoom: sessionStorage.getItem('currentMonitorMapZoom') || this.zoom, //sessionStorage存在瀏覽器
          minZoom: 7,
          maxZoom: 18,
          // extent: transformExtent(extentBound, 'EPSG:4326', 'EPSG:3857'), //上下左右滑動的邊界(有用到座標的地方記得轉換)
        })
      },
      // layer>source>feature
      // 一個layer只能有一個source，一個source可以有多個feature
      // 以向量的方式新增一個向量的數據來源
      vectorSource() {
        // 以點(point)的方式新增要素(feature)
        const tmpFeature = new Feature({
            geometry: new Point(fromLonLat(this.featureCoordinate)),
            name: 'marker',
          });
        // 將要素放到數據來源(source)裡面，vector:向量類型。
        return new Vector({
          features: [tmpFeature],
          format: new GeoJSON(),
        })
      },
      // 用向量新增一個圖層，用來標示目前所在位置的marker
      // 一層layer裡面，要有一個數據來源source，而source包含了很多地理要素features
      pointsLayer() {
        const layer = new VectorLayer({
          source: this.vectorSource,
          style: () => {
            let style = null;

            switch (this.currentCarInfo.carStatus) {
              case 0:
                style = flameoutMarkerStyle;
                break;
              case 1:
                style = drivingMarkerStyle;
                break;
              case 2:
                style = idleMarkerStyle;
                break;
              case 3:
                style = lostMarkerStyle;
                break;
              default:
                break;
            }

            if(this.currentCarInfo.carStatus ===1 || this.currentCarInfo.carStatus ===2) {
              if(Math.floor(new Date().getTime())-this.currentCarInfo.time > this.tenＭinutes) {
                style = lostMarkerStyle;
              }
            }

            style.getImage().setRotation((this.currentCarInfo.azimuth - 90) * Math.PI * 2 / 360);
            //預設方向角是往南，這張圖是向右，所以要減90度，修正到往南邊，
            return style;
          }
        });

        return layer;
      },
      carStatusText() {
        let text = '';

        switch (this.currentCarInfo.carStatus) {
          case 1:
            text = '行駛中';
            break;
          case 2:
            text = '怠速中';
            break;
          case 3:
            text = '熄火';
            break;
          case 4:
            text = '失聯';
            break;
          default:
            text = '--';
            break;
        }
        if(this.currentCarInfo.carStatus ===1 || this.currentCarInfo.carStatus ===2) {
          if(Math.floor(new Date().getTime())-this.currentCarInfo.time > this.tenＭinutes) {
            text = '失聯';
          }
        }
        return text;
      },
      carSpeed() {
        let speed = null;
        speed = (this.productName === 'STMB-4000') ? this.currentCarInfo.gpsSpeed : this.currentCarInfo.speed;

        if(this.currentCarInfo.carStatus ===1 || this.currentCarInfo.carStatus ===2) {
          if(Math.floor(new Date().getTime())-this.currentCarInfo.time > this.tenＭinutes) {
            speed = '--';
          }
        }

        return speed;
      },
      locationText(){
        if(this.isAddress){
          return `${this.currentCarInfo.longitude} , ${this.currentCarInfo.latitude}`//顯示地標
        }else{
          return `${this.currentCarInfo.longitude} , ${this.currentCarInfo.latitude}`//todo 顯示地址 ps disabled判斷結果需調整為 disabled: ''
        }
      }
    },
    beforeDestroy() { //  離開這頁的時候，將socket斷線
      this.ws.disconnect();
    },
  };
</script>

<style scoped lang="scss">
  .map_container {
    height: calc(100vh - 80px);
    top: 53px;
    #map {
        position: absolute;
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
        background-color: rgb(163, 203, 255);
      }
      ul {
        list-style: none;
        padding: 11px 14px;
        margin: 0;
        width: 94%;
        height: 100px;
        background: #FFFF;
        bottom: 0;
        position: fixed;
        z-index: 2;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 8px 8px 0 0;
        box-shadow: 0px 0px 0.8px rgb(0 0 0 / 6%), 0px 0px 2px rgb(0 0 0 / 4%), 0px 0px 5px rgb(0 0 0 / 4%), 0px 0px 17px rgb(0 0 0 / 3%);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        li {
          color: #343741;
          font-size: 14px;
          line-height: 24px;
          font-weight: 500;
          display: flex;
          align-items: center;
          .map_info_icon {
            width: 22px;
            height: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 12px;
          }
          .exchange-icon{
            padding-top: 3px;
            margin-left: auto;
            &.ant-btn:hover:not(.disabled), &.ant-btn:focus:not(.disabled){
              border-color: #648bb2;
            }
            &.disabled{
              border-color: transparent;
              svg path{
                fill: #bfbfbf;
              }
            }
          }
          span {
            display: inline-block;
            margin-right: 10px;
          }
        }
      }

      .expired_btn {
        position: absolute;
        z-index: 2;
        border-radius: 6px;
        border: transparent;
        padding: 12px;
        background-color: #FFFF;
        box-shadow: 0px 2.7px 9px rgba(0, 0, 0, 0.13), 0px 9.4px 24px rgba(0, 0, 0, 0.09), 0px 21.8px 43px rgba(0, 0, 0, 0.08);
        color: #F10000;
        left: 50%;
        top: 24px;
        transform: translateX(-50%);
        font-size: 16px;
        line-height: 24px;
        width: 70%;
      }

      .no_record_btn {
        position: absolute;
        z-index: 2;
        border-radius: 6px;
        border: transparent;
        padding: 12px;
        background-color: #FFFF;
        box-shadow: 0px 2.7px 9px rgba(0, 0, 0, 0.13), 0px 9.4px 24px rgba(0, 0, 0, 0.09), 0px 21.8px 43px rgba(0, 0, 0, 0.08);
        color: #343741;
        left: 50%;
        top: 35%;
        transform: translatex(-50%);
        font-size: 16px;
        line-height: 24px;
        width: 70%;
      }
  }


</style>
